
import React from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './khristian2.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Pkhristian2 = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {





  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id64cc07c79255464525645680" >

      <div id="i55h" className="">
      
      <div id="id6iic" className="">
      
        <a
          target=""
          className=""
          id="ikuk3f"
          href="/"
        >
          
      <img
        className=""
        id="i9pt4f"
        src="https://assetsprojects.s3.amazonaws.com/405opfilkr1t22z.png"
        alt="undefined"
      />
      
        </a>
        
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/quienessomos"
        type=""
      >
        <>Quienes Somos</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/aprende"
        type=""
      >
        <>Aprende</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/#ijf0dn"
        type=""
      >
        <>Preguntas Frecuentes</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/#ijn4q"
        type=""
      >
        <>Contáctanos</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      <div id="izuf7m" className="">
      
        <a
          target=""
          className=""
          id="i3mkrh"
          href={`/quienessomos`}
        >
          
      <div className="" id="ilb64w">
        <>Quiénes Somos</>
      </div>
      
        </a>
        
        <a
          target=""
          className=""
          id="ibhmfa"
          href="#"
        >
          
      <div className="" id="il1q3h">
        <>Aprende</>
      </div>
      
        </a>
        
        <a
          target=""
          className=""
          id="i7q4zk"
          href={`/pruebasluis`}
        >
          
      <div className="" id="it6im4">
        <>Preguntas Frecuentes</>
      </div>
      
        </a>
        
        <a
          target=""
          className=""
          id="ilbw8k"
          href={`/pruebasluis`}
        >
          
      <div className="" id="ixd91v">
        <>Contáctanos</>
      </div>
      
        </a>
        
      </div>
      
      </div>
      
      <div id="icv7c" className="">
      
      </div>
      
      <div id="ifxad2" className="">
      
      <div id="ijzglu" className="">
      
      <div className="" id="isdsyu">
        <>El Valor e Impacto de Realizar una Gestión Activa con la Liquidez de la EMPRESA</>
      </div>
      
      <div id="icj91z" className="">
      
      <div className="" id="ibmtil">
        
      <u className="" id="">
        
      <b className="" id="">
        <>Resumen</>
      </b>
      
      <br className="" id="" />
      
      </u>
      
      <br className="" id="" />
      <>Existen numerosos estudios que buscan determinar si la gestión activa en el mercado accionario puede generar una rentabilidad superior a los indicies accionarios. ¿Pero qué hay sobre el manejo de efectivo de las empresas? ¿Es posible generar mayores retornos a través de una gestión activa? La respuesta corta es SI.</>
      <br className="" id="" />
      
      <i className="" id="">
        
      <b className="" id="">
        <>*Gestión Pasiva:</>
      </b>
      
      </i>
      <> Cuando no realizas ninguno o pocos movimientos de liquidez en búsqueda de maximizar la rentabilidad de la liquidez circulante de la empresa.</>
      <br className="" id="" />
      
      <i className="" id="">
        
      <b className="" id="">
        <>*Gestión Activa:</>
      </b>
      
      </i>
      <> Cuando realizas movimientos de liquidez buscando maximizar su rentabilidad teniendo en cuenta la información del flujo de caja y de las mejores opciones del mercado.</>
      <br className="" id="" />
      
      <br className="" id="" />
      
      <u className="" id="">
        
      <b className="" id="">
        <>Metodología</>
      </b>
      
      </u>
      
      <br className="" id="" />
      <>En 2021, llevamos a cabo un estudio con 10 empresas que adoptaron una gestión pasiva, analizando su comportamiento y la rentabilidad generada a partir de su liquidez circulante. Simultáneamente, realizamos una simulación de la gestión activa para estimar el diferencial de rentabilidad que podrían haber obtenido. Posteriormente, en 2022 y 2023, observamos los resultados reales que se materializaron en empresas que optaron por la gestión activa, aprovechando las oportunidades brindadas por la herramienta TRET.</>
      <br className="" id="" />
      
      <br className="" id="" />
      <>Esta comparativa nos proporcionó una visión más clara sobre el impacto de la gestión activa en la rentabilidad de las empresas, y los resultados obtenidos en 2022 y 2023 respaldan los beneficios potenciales que puede brindar la adopción de esta estrategia.</>
      <br className="" id="" />
      
      <b className="" id="">
        <>Nota.</>
      </b>
      <> Es importante anotar que poder hacer estos movimientos de liquidez a través de la “Fiducuenta” de la empresa permitirá poder utilizar diferentes bancos sin tener que incurrir en el 4x1000, siempre y cuando todos sus productos estén asociados a un mismo número de NIT.</>
      <br className="" id="" />
      
      <br className="" id="" />
      
      <b className="" id="">
        
      <u className="" id="">
        <>Resultados</>
      </u>
      
      </b>
      
      <br className="" id="" />
      <>Sobre los últimos tres años de simulación (Backtesting), TRET superó considerablemente la gestión pasiva que se puede estar observando en las empresas del sector real. Las empresas que tuvieron una gestión activa con TRET lograron tener una rentabilidad superior de 10% en 2023 a las empresas que mantuvieron una gestión pasiva.</>
      <span className="" id="igmzke">
        
      </span>
      
      </div>
      
      <div id="idfned" className="">
      
      <img
        className=""
        id="itxz8c"
        src="https://assetsprojects.s3.amazonaws.com/405opfilkvlu8s3.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="ivud6j">
        
      <a
        target="_blank"
        className=""
        id="ihb7h4"
        href="/gestionactiva2"
        type=""
      >
        <>¿Cómo lograr hacer una gestión activa? </>
      </a>
      
      <br className="" id="" />
      
      <b className="" id="">
        
      <u className="" id="">
        <>Conclusiones:</>
      <br className="" id="" />
      
      </u>
      
      </b>
      <>Tener una gestión activa nos ayudará como empresa a:</>
      <br className="" id="" />
      
      <b className="" id="">
        <>1.</>
      </b>
      <> Generar más rentabilidad con la liquidez de tu empresa</>
      <br className="" id="" />
      
      <b className="" id="">
        <>2.</>
      </b>
      <> Reducir costos financieros </>
      <br className="" id="" />
      
      <b className="" id="">
        <>3. </>
      </b>
      <>Tener mayor control sobre las finanzas de tu empresa</>
      <br className="" id="" />
      <> con resultados y la experiencia del equipo de TRET</>
      <br className="" id="" />
      
      <b className="" id="">
        <>Empieza ya!</>
      </b>
      
      <br className="" id="" />
      <>Haz fácil una buena gestión, teniendo las respuestas a la mano.  En TRET estamos comprometidos con acompañar y brindar + tranquilidad + tiempo + dinero a nuestros clientes.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i5of" className="">
      
      <div id="i8lmjf" className="">
      
      <div id="im4a28" className="">
      
      <img
        className=""
        id="iteqmg"
        src="https://assetsprojects.s3.amazonaws.com/405opfilkr5bykb.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iqpkke" className="">
      
      <div className="" id="iy8adh">
        <>Dirección</>
      </div>
      
      <div className="" id="iiauur">
        <>Bogotá, Colombia</>
      </div>
      
      </div>
      
      <div id="imh7h6" className="">
      
      <div className="" id="ijoril">
        <>Correo de contacto</>
      </div>
      
      <div className="" id="ik2c1u">
        <>info@tret.com.co</>
      </div>
      
      </div>
      
      </div>
      
      <div id="iw4n9w" className="">
      
      <div id="ianz3m" className="">
      
      </div>
      
      <div id="iufalf" className="">
      
      <div className="" id="ij1xap">
        <>Coyright©2023 TRET - Todos los derechos reservados.</>
      </div>
      
      <div id="ielirh" className="">
      
      <img
        className=""
        id="ii3z3k"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk14hfve.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="i1414e"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk14i6xh.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="it3ooa"
        src="https://assetsprojects.s3.amazonaws.com/405gzoilk14iokp.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pkhristian2);
  